<template>
  <div class="horizontal-orange animated slideInLeft faster">
    <div id="lottie"><canvas id="canvas"></canvas></div>
  </div>
</template>

<script>
import * as lottie from 'lottie-web/build/player/lottie.js'

export default {
  name: 'horizontal-orange',
  props: ['animation', 'loop'],
  components: {
  },
  data() {
    return {
      shouldLoop: this.loop === true,
      element: null,
      params: {}
    }
  },
  methods: {
    loadLottie: function(params) {
      lottie.loadAnimation(params)
    }
  },
  mounted() {
    this.params = {
        container: document.getElementById('lottie'),
        renderer: 'html',
        loop: this.shouldLoop,
        autoplay: true,
        animationData: this.animation,
        rendererSettings: {
          context: document.getElementById('lottie'), // the canvas context
          scaleMode: 'noScale',
          clearCanvas: true,
          progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
          hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
          className: 'animation'
        }
    };

    
    document.addEventListener('animationend', this.loadLottie(this.params))
  },
  beforeDestroy() {
    document.removeEventListener('animationend', this.loadLottie)
  }
}
</script>

<style lang="scss" scoped>
.horizontal-orange {
  background: url("~@/assets/orange2.png") center center no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
}

#lottie{
  width:40%;
  height:100%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: left;
  opacity: 1;
  z-index: 1;

  canvas {
    height: 100%;
    width: 400px;
  }
}

</style>
